import { Injectable } from '@angular/core';
import { PaymentSettings } from '../interfaces/payment-settings';

@Injectable({
  providedIn: 'root',
})
export class PaymentSettingsAdapter {
  public adapterToModel(paymentSettingsAPI: PaymentSettings): PaymentSettings {
    return {
      ...paymentSettingsAPI,
      min_day_before_encounter: this.normalizeMinDayBeforeEncounter(paymentSettingsAPI.min_day_before_encounter),
    };
  }

  public adaptToAPIFormat(paymentSettingsModel: PaymentSettings): PaymentSettings {
    const paymentSettingsAPI: PaymentSettings = {
      organization_id: paymentSettingsModel.organization_id,
      healthcare_plans: paymentSettingsModel.healthcare_plans,
      payment_methods: paymentSettingsModel.payment_methods,
      min_day_before_encounter: this.normalizeMinDayBeforeEncounter(paymentSettingsModel.min_day_before_encounter),
      secretary_commission_percentage: paymentSettingsModel.secretary_commission_percentage,
      organization_percentage: paymentSettingsModel.organization_percentage,
      register_information: paymentSettingsModel.register_information,
      bank_account: paymentSettingsModel.bank_account
        ? {
            holder_name: paymentSettingsModel.bank_account.holder_name,
            holder_type: paymentSettingsModel.bank_account.holder_type,
            holder_document: paymentSettingsModel.bank_account.holder_document,
            bank: paymentSettingsModel.bank_account.bank,
            bank_number: paymentSettingsModel.bank_account.bank_number,
            branch_number: paymentSettingsModel.bank_account.branch_number,
            branch_check_digit: paymentSettingsModel.bank_account.branch_check_digit,
            account_number: paymentSettingsModel.bank_account.account_number,
            account_check_digit: paymentSettingsModel.bank_account.account_check_digit,
            type: paymentSettingsModel.bank_account.type,
            bank_name: paymentSettingsModel.bank_account.bank_name,
            agency_number: paymentSettingsModel.bank_account.agency_number,
            account_type: paymentSettingsModel.bank_account.account_type,
          }
        : undefined,
      transfer_settings: paymentSettingsModel.transfer_settings
        ? {
            transfer_interval: paymentSettingsModel.transfer_settings.transfer_interval,
            transfer_day: paymentSettingsModel.transfer_settings.transfer_day,
          }
        : undefined,
    };

    return paymentSettingsAPI;
  }

  private normalizeMinDayBeforeEncounter(value: unknown): number | undefined {
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
      return undefined;
    }

    const normalizedValue = Number(value);
    return Number.isFinite(normalizedValue) ? normalizedValue : undefined;
  }
}
